import React from 'react';
import { Box, Link, Typography } from '@mui/material';

export default function Footer() {
  // Using the conventional email format; if you want the literal 'info:trade-vue.com' change this.
  const mailto = 'mailto:info@trade-vue.com';

  return (
    <Box component="footer" sx={{ mt: 4, py: 2, bgcolor: 'background.paper', textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        <Link href={mailto} color="inherit" underline="hover">Feedback</Link>
      </Typography>
    </Box>
  );
}
